import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/layout/template.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/v2/components/RenderBlocks/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/v2/components/RenderHeroBlock/index.tsx")